import { getApp, getApps, initializeApp, type FirebaseApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, type Auth } from 'firebase/auth';
import { firebaseOptions, useFirebaseEmulators } from './config';

export interface FirebaseServices {
  readonly app: FirebaseApp;
  readonly auth: Auth;
}

let services: FirebaseServices | undefined;
let emulatorsConnected = false;

export function getFirebaseServices(): FirebaseServices {
  if (services) return services;

  const app = getApps().length > 0 ? getApp() : initializeApp(firebaseOptions);
  const auth = getAuth(app);

  if (useFirebaseEmulators && !emulatorsConnected) {
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
    emulatorsConnected = true;
  }

  services = { app, auth };
  return services;
}
